import React from 'react';
import { motion } from 'framer-motion';

const teamMembers = [
  {
    name: '鍾秉均',
    role: '總召',
    contact: 'programchung@gmail.com',
    avatar: '/assets/images/placeholder.jpg',
  },
  {
    name: '李日森',
    role: '行政',
    contact: 'rihsen.la13@nycu.edu.tw',
    avatar: '/assets/images/placeholder.jpg',
  },
];

const Team = () => {
  return (
    <section className="py-20 px-10 bg-gray-50 min-h-screen">
      <motion.h1
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-4xl font-bold text-center text-secondary mb-6"
      >
        籌備人員介紹
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-center text-gray-700 mb-10"
      >
        我們的團隊成員來自各方專家，致力打造優質營隊。
      </motion.p>
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {teamMembers.map((m, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            whileHover={{ scale: 1.05 }}
            className="bg-white p-6 rounded-2xl shadow-lg text-center"
          >
            <div className="bg-gray-200 border-2 border-dashed rounded-full w-24 h-24 mx-auto mb-4 flex items-center justify-center">
              <span className="text-gray-500">頭像</span>
            </div>
            <h3 className="text-xl font-semibold">{m.name}</h3>
            <p className="text-gray-600">{m.role}</p>
            <a href={`mailto:${m.contact}`} className="text-primary hover:underline">{m.contact}</a>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Team;